import React from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import AppraisalForm from '../components/AppraisalForm';
import Layout from '../../../components/Layout';
const AppraisalFormPage = () => {
  const { id } = useParams();
  const isEditing = !!id;

  return (
    <Layout>
      <AppraisalForm isEditing={isEditing} />
    </Layout>
  );
};

export default AppraisalFormPage;
